import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import api from '../services/api';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuthStore();
  const [profil, setProfil] = useState<any>(null);
  const [streak, setStreak] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);
  const [sidebarDeschis, setSidebarDeschis] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [mobileMenuDeschis, setMobileMenuDeschis] = useState(false);

  useEffect(() => {
    api.get('/profil/get').then(r => {
      setProfil(r.data);
      setIsAdmin(r.data?.is_admin || false);
    }).catch(() => {});
    api.get('/tracker/streak').then(r => setStreak(r.data.streak)).catch(() => {});
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) setMobileMenuDeschis(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Inchide meniul mobile la navigare
  useEffect(() => {
    setMobileMenuDeschis(false);
  }, [location]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItem = (path: string, icon: string, label: string) => {
    const activ = location.pathname === path;
    return (
      <button onClick={() => navigate(path)} title={label} style={{
        width: '100%',
        textAlign: (!isMobile && !sidebarDeschis) ? 'center' : 'left',
        padding: (!isMobile && !sidebarDeschis) ? '0.6rem 0' : '0.6rem 0.75rem',
        borderRadius: '8px', border: 'none', cursor: 'pointer',
        background: activ ? '#1e1e3a' : 'transparent',
        color: activ ? '#ffffff' : '#a0a0c0',
        fontSize: (!isMobile && !sidebarDeschis) ? '1.2rem' : '0.875rem',
        fontWeight: activ ? 600 : 400,
        marginBottom: '2px',
        transition: 'all 0.2s ease',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
      }}>
        {(!isMobile && !sidebarDeschis) ? icon : `${icon} ${label}`}
      </button>
    );
  };

  const SidebarContent = () => (
    <>
      <div style={{ padding: isMobile ? '1rem' : (sidebarDeschis ? '1.5rem 1rem' : '1.5rem 0.5rem') }}>
        {(isMobile || sidebarDeschis) ? (
          <>
            <h2 style={{ color: '#fff', marginBottom: '0.25rem', fontSize: '1.2rem' }}>🩺 Flexara</h2>
            {profil && <p style={{ color: '#6060a0', fontSize: '0.8rem', marginBottom: '1rem' }}>Salut, {profil.nume}!</p>}
          </>
        ) : (
          <p style={{ textAlign: 'center', fontSize: '1.4rem', marginBottom: '1rem' }}>🩺</p>
        )}

        {streak > 0 && (
          <div style={{
            background: streak >= 7 ? '#0f2a1a' : streak >= 3 ? '#2a1a00' : '#1a1a2e',
            borderRadius: '8px',
            padding: (isMobile || sidebarDeschis) ? '0.5rem 0.75rem' : '0.5rem 0',
            marginBottom: '1rem',
            fontSize: '0.8rem',
            color: streak >= 7 ? '#60d090' : streak >= 3 ? '#d0a040' : '#a0a0d0',
            textAlign: (isMobile || sidebarDeschis) ? 'left' : 'center',
            whiteSpace: 'nowrap',
            overflow: 'hidden'
          }}>
            {streak >= 7
              ? ((isMobile || sidebarDeschis) ? `⚡ Seria: ${streak} zile!` : '⚡')
              : streak >= 3
              ? ((isMobile || sidebarDeschis) ? `🔥 Seria: ${streak} zile!` : '🔥')
              : ((isMobile || sidebarDeschis) ? `📅 Seria: ${streak} zile` : '📅')}
          </div>
        )}

        <hr style={{ borderColor: '#1e1e3a', margin: '0.5rem 0 0.5rem' }} />

        {(isMobile || sidebarDeschis) && (
          <p style={{ color: '#4a4a6a', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.5rem' }}>Navigare</p>
        )}

        {navItem('/', '🏠', 'Acasă')}
        {navItem('/chat', '💬', 'Chat nou')}
        {navItem('/tracker', '📊', 'Tracker Durere')}
        {navItem('/plan', '📋', 'Plan Recuperare')}
        {navItem('/profil', '👤', 'Profilul meu')}

        {isAdmin && (
          <>
            {(isMobile || sidebarDeschis) && <hr style={{ borderColor: '#1e1e3a', margin: '0.75rem 0' }} />}
            {(isMobile || sidebarDeschis) && <p style={{ color: '#4a4a6a', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.5rem' }}>Admin</p>}
            {navItem('/admin', '⚙️', 'Dashboard Admin')}
          </>
        )}
      </div>

      <div style={{ flex: 1 }} />

      <div style={{ padding: '1rem' }}>
        {(isMobile || sidebarDeschis) && (
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '0.5rem' }}>
            {[
              { label: 'Termeni', path: '/termeni' },
              { label: 'Confidențialitate', path: '/confidentialitate' },
              { label: 'Cookies', path: '/cookies' }
            ].map((link, i) => (
              <span key={i} onClick={() => navigate(link.path)}
                style={{ color: '#4a4a6a', fontSize: '0.65rem', cursor: 'pointer', textDecoration: 'underline' }}>
                {link.label}
              </span>
            ))}
          </div>
        )}
        {(isMobile || sidebarDeschis) && (
          <p style={{ color: '#4a4a6a', fontSize: '0.65rem', lineHeight: 1.4, marginBottom: '0.75rem' }}>
            Scop educativ. Nu înlocuiește consultul medical.
          </p>
        )}
        <button onClick={handleLogout} title="Deconectare" style={{
          width: '100%', padding: '0.6rem', borderRadius: '8px',
          border: '1px solid #2a2a4a', background: 'transparent',
          color: '#6060a0', cursor: 'pointer',
          fontSize: (isMobile || sidebarDeschis) ? '0.85rem' : '1.2rem',
          textAlign: (isMobile || sidebarDeschis) ? 'left' : 'center'
        }}>
          {(isMobile || sidebarDeschis) ? '🚪 Deconectare' : '🚪'}
        </button>
      </div>
    </>
  );

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#12121f', fontFamily: 'DM Sans, sans-serif' }}>

      {/* MOBILE — overlay menu */}
      {isMobile && mobileMenuDeschis && (
        <div
          onClick={() => setMobileMenuDeschis(false)}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.6)', zIndex: 40
          }}
        />
      )}

      {/* MOBILE — sidebar drawer */}
      {isMobile && (
        <div style={{
          position: 'fixed', top: 0, left: 0, bottom: 0,
          width: '280px',
          background: '#0a0a15',
          borderRight: '1px solid #1e1e3a',
          display: 'flex', flexDirection: 'column',
          zIndex: 50,
          transform: mobileMenuDeschis ? 'translateX(0)' : 'translateX(-100%)',
          transition: 'transform 0.25s ease'
        }}>
          <SidebarContent />
        </div>
      )}

      {/* DESKTOP — sidebar normal */}
      {!isMobile && (
        <div style={{
          width: sidebarDeschis ? '240px' : '60px',
          minWidth: sidebarDeschis ? '240px' : '60px',
          background: '#0a0a15',
          borderRight: '1px solid #1e1e3a',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          transition: 'all 0.25s ease'
        }}>
          <button onClick={() => setSidebarDeschis(!sidebarDeschis)} style={{
            position: 'absolute', right: '-12px', top: '24px',
            width: '24px', height: '24px', borderRadius: '50%',
            background: '#1e1e3a', border: '1px solid #2a2a4a',
            color: '#a0a0c0', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '0.7rem', zIndex: 10, padding: 0
          }}>
            {sidebarDeschis ? '◀' : '▶'}
          </button>
          <SidebarContent />
        </div>
      )}

      {/* Continut principal */}
      <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', paddingTop: isMobile ? '56px' : '0' }}>
        {/* MOBILE — top bar cu hamburger */}
        {isMobile && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: '1rem',
            padding: '0.75rem 1rem',
            background: '#0a0a15',
            borderBottom: '1px solid #1e1e3a',
            position: 'fixed', top: 0, left: 0, right: 0, zIndex: 30
          }}>
            <button onClick={() => setMobileMenuDeschis(true)} style={{
              background: 'transparent', border: 'none', color: '#a0a0c0',
              fontSize: '1.4rem', cursor: 'pointer', padding: '0.25rem'
            }}>☰</button>
            <h2 style={{ color: '#fff', margin: 0, fontSize: '1rem' }}>🩺 Flexara</h2>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default Layout;